import { render, staticRenderFns } from "./date-range.vue?vue&type=template&id=bfc0025a&"
import script from "./date-range.vue?vue&type=script&lang=js&"
export * from "./date-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc0025a')) {
      api.createRecord('bfc0025a', component.options)
    } else {
      api.reload('bfc0025a', component.options)
    }
    module.hot.accept("./date-range.vue?vue&type=template&id=bfc0025a&", function () {
      api.rerender('bfc0025a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/qm-date-picker/src/panel/date-range.vue"
export default component.exports